import sortBy from 'lodash/sortBy';

import type { Ring } from '@/app/[locale]/product/_hooks/types';
import { RingFinishEnum } from '@/app/enums/RingFinishEnum';

const sortFinishes = (rings: Ring[] | undefined): Ring[] => {
  if (!rings) return [];

  const topFinish = rings.find((ring) => ring.finish === RingFinishEnum.Silver);
  const otherFinishes = rings.filter(
    (ring) => ring.finish !== RingFinishEnum.Silver,
  );
  const sortedFinishes = sortBy(otherFinishes, ['price.amount']);

  if (!topFinish) return sortedFinishes;

  return [topFinish, ...sortedFinishes];
};

export default sortFinishes;
